import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ScanResult, ScanService } from '@definitiv-packages/angular-dba-library';
import { SafetyPointModel } from '../../../../../roofsafetymanagement-library/src/public-api';

@Component({
  selector: 'app-safetypoint-suche-view',
  templateUrl: './safetypoint-suche-view.component.html',
  styleUrls: ['./safetypoint-suche-view.component.scss'],
  standalone: false
})
export class SafetypointSucheViewComponent implements OnInit, OnDestroy {
  

  constructor(
    private scanService: ScanService,

    private router: Router
  ) { }

  public ngOnInit(): void {
    
  }

  public ngOnDestroy(): void {
    
  }

  public handleSafetypointSelected(safetypoint: SafetyPointModel): void {
    this.router.navigate(['safetypointInfo', safetypoint.SafetyPointId]);
  }

  private handleScan(input: ScanResult): void {
    // if (input.Prefix == ScanPrefix.GebrauchsgutID) {
    //   this.appService.navigateToCommodityInfoView(getCommodityIdFromScan(input.Text));
    // }
  }
}
